export const sizeConfig = {
  small: {
    headingSize: 'medium',
    textSize: 'small',
    buttonSize: 'small',
    benefitsMarginBottom: '18px',
    mainContainerGap: '0px',
  },
  large: {
    headingSize: 'large',
    textSize: 'medium',
    buttonSize: 'medium',
    benefitsMarginBottom: '36px',
    mainContainerGap: '24px',
  },
} as const;
